import { I_DrsPlaygroundState } from "@/store/modules/drsPlayground/lib/models/interfaces";

const state: I_DrsPlaygroundState = {
  generatedTasks: [],
  selectedViewItem: null,
  selectedViewItemGraphics: [],
};

export default state;
